import { useTranslation } from "react-i18next";
import { LeadFormComp } from "../../app/landingPage/LeadFormComp";
import { toast } from "react-toastify";

export const LeadForm = ({ utms }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col items-center">
      <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-2 px-4 sm:px-8 pt-3">
        {t("Claim Your Free Setup & Retailer Offers")}
      </h3>
      <p className="text-muted-foreground mb-4 md:mb-6 text-xs sm:text-sm px-4 sm:px-8">
        {t("Join 1000+ Egyptian stores already growing their business")}
      </p>

      <div className="flex w-11/12 pb-2 md:w-4/5 md:pb-5 ">
        {/* <iframe
          src="https://crm.zoho.com/crm/WebFormServeServlet?rid=fdf424ec82e2400ed70107fff13246c1cd27a1d2be0ce62cd7f8a17789c66f32c6eb1bdad4569570744b1461c7adfe35gid6a1af47951c39becbe9fadf126b47865c04a7648500a721fb89f1703309a5ecc"
          title="Zoho Form"
          className="md:w-[610px] md:h-[364px] w-[305px] h-[470px]"
        ></iframe> */}
        <LeadFormComp
          formSubmit={() => {
            toast.success(t("myGINNE will contact you soon!"));
          }}
          formSubmitDone={() => console.log("formsubmitted")}
          utms={utms}
        />
      </div>
    </div>
  );
};
